<template>
    <div :class="'date-time-picker' + (toggle_fields && smart_inputs ? '--toggle_fields' : '')">
        <div v-if="smart_inputs" class="date-time-picker--smart-inputs">
            <div v-if="day !== ''" class="date">
                <div class="date-time-picker--smart-inputs--text">data</div>
                <b-form-input
                    :class="is_valid_date_text ? '' : 'danger'"
                    size="sm"
                    v-model="smart_day_text"
                    placeholder="gg-mm-aaaa"
                    @click="() => {
                        if(! (toggle_fields && smart_inputs) ) return
                        this.toggle = !this.toggle
                    }"
                    @input="(value) => {
                        let new_day = format_smart_day(value)
                        if(new_day !== '') internal_day = new_day.split('-')[2] + '-' + new_day.split('-')[1] +'-'+ new_day.split('-')[0]
                    }"
                ></b-form-input>
            </div>
            <div v-if="hour !== ''" class="hour">
                <div class="date-time-picker--smart-inputs--text">ora</div>
                <b-form-input
                    :class="is_valid_hour_text ? '' : 'danger'"
                    size="sm"
                    v-model="smart_hour_text"
                    placeholder="hh:mm"
                    @click="() => {
                        if(! (toggle_fields && smart_inputs) ) return
                        this.toggle = !this.toggle                        
                    }"
                    @input="(value) => {
                        let new_hour = format_smart_hour(value)
                        if(new_hour !== '') internal_hour = new_hour
                    }"
                ></b-form-input>
            </div>
        </div>
        <div class="date-time-picker--body" v-if="header" v-show="toggle">
            <b-calendar
                v-if="day !== ''"
                class="date-time-picker--calendar"
                v-model="internal_day"
                locale="it"
                size="sm"
                block
                @input="selected_day"
                :min="min"
                :max="max"
            ></b-calendar>
            <b-time
                v-if="hour !== ''"
                class="date-time-picker--time"
                v-model="internal_hour"
                locale="it"
                size="sm"
                @input="selected_hour"
            ></b-time>
        </div>
        <div class="date-time-picker--body" v-else v-show="toggle">
            <b-calendar
                v-if="day !== ''"
                class="date-time-picker--calendar"
                v-model="internal_day"
                locale="it"
                size="sm"
                block
                @input="selected_day"
                hide-header
                :min="min"
                :max="max"
            ></b-calendar>
            <b-time
                v-if="hour !== ''"
                class="date-time-picker--time"
                v-model="internal_hour"
                locale="it"
                size="sm"
                hide-header
                @input="selected_hour"
            ></b-time>
        </div>
    </div>
</template>

<script>

import { reverse_date } from '@/utilities'
export default {
    name: 'date-time-picker',
    components:
    {
    },
    created()
    {
        this.reverse_date = reverse_date
    },
    props:
    {
        toggle_fields: {
            type: Boolean,
            default: false,
        },
        day: {
            type: String,
            default: '',
        },
        hour: {
            type: String,
            default: '',
        },
        context: {
            type: Object,
            default: () => {}
        },
        header: {
            type: Boolean,
            default: true,
        },
        smart_inputs: {
            type: Boolean,
            default: false,
        },
        min: {
            type: Date,
            default: () => {
                let now = new Date(),
                    today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                return new Date(today)
            },
        },
        max: {
            type: Date,
            default: () => {
                let now = new Date(),
                    today = new Date(2099, now.getMonth(), now.getDate())
                return new Date(today)
            },
        },
    },
    computed: {
    },
    mounted()
    {
        if(this.smart_inputs)
        {
            this.smart_day_text = this.format_smart_day(
                this.day.split('-')[2] + '-' + this.day.split('-')[1] +'-'+ this.day.split('-')[0]
            )

            this.smart_hour_text = this.format_smart_hour(this.hour)
        }
    },
    data(){
        let toggle = true

        if(this.toggle_fields && this.smart_inputs) toggle = false

        return {
            internal_day: this.day,
            internal_hour: this.hour,
            smart_day_text: '',
            smart_hour_text: '',
            is_valid_date_text: true,
            is_valid_hour_text: true,
            toggle: toggle,
        }
    },
    methods:
    {
        send_update()
        {
            this.$emit('updated',{
                day: this.internal_day,
                hour: this.internal_hour,
                context: this.context,
            })
        },
        selected_day()
        {
            this.smart_day_text = this.format_smart_day( this.reverse_date(this.internal_day) )
            this.send_update()
        },
        selected_hour()
        {
            this.smart_hour_text = this.format_smart_hour(this.internal_hour)
            this.send_update()
        },
        format_smart_day(text_day)
        {
            text_day = text_day.replace(/\D/g,' ').replace(/\s\s+/g, ' ')
            let smart_day_split = text_day.split(' '),
                day = smart_day_split[0],
                month = smart_day_split[1],
                year = smart_day_split[2]
            
            let is_valid = ((new Date(month+'-'+day+'-'+year)).getTime())

            if(
                !is_valid ||
                !day ||
                !month ||
                !year ||
                year.length !== 4
            )
            {
                this.is_valid_date_text = false
                return ''
            }

            if (day.length == 1) day = '0'+day.toString()
            if (month.length == 1) month = '0'+month.toString()

            this.is_valid_date_text = true
            return day+'-'+month+'-'+year
        },
        format_smart_hour(text_hour)
        {
            text_hour = text_hour.replace(/\D/g,' ').replace(/\s\s+/g, ' ')
            let smart_hour_split = text_hour.split(' '),
                hour = parseInt(smart_hour_split[0]),
                minutes = parseInt(smart_hour_split[1])

            let is_valid = ( hour <= 23 && hour >= 0 && minutes <= 60 && minutes >= 0 )

            if(!is_valid)
            {
                this.is_valid_hour_text = false
                return ''
            }

            if (hour.toString().length == 1) hour = '0'+hour.toString()
            if (minutes.toString().length == 1) minutes = '0'+minutes.toString()
            
            this.is_valid_hour_text = true
            return hour+':'+minutes
        }
    }
}
</script>

<style lang="scss">
    .date-time-picker
    {
        display: block;
        button
        {
            outline:none !important;
            box-shadow: none !important;
        }   
        &--calendar
        {
            margin-bottom:10px;
            width: 100%;
            .b-calendar-grid
            {
                border-radius: 0;
                padding:10px 0 0 0;
                box-shadow: none !important;
                border-color: $gray-400 !important;
            }
            //.b-calendar-grid-header
            .form-control
            {
                border-radius: 0;
            }
            .b-calendar-grid-body
            {
                margin:5px 0;
            }
            .btn
            {
                box-shadow: none !important;;
                border:0 !important;
                outline:none !important;
                padding:6px 10px;
                border-radius: 0 !important;
            }
            .b-calendar-nav
            {
                background:$white;
                border:1px solid $gray-400;
                border-bottom:0;
                margin-top:-1px;
            }
            .b-calendar-grid-help,
            button:first-child,
            button:last-child
            {
                display:none;
            } 
            .b-calendar-grid-body .no-gutters > .col
            {
                max-width:14%;
                *
                {
                    font-size:14px;
                }
            }    
        }
        &--time
        {
            width: 100%;
            .b-time-header
            {
                margin-bottom:10px;
            }
            .form-control
            {
                border-radius: 0;
            }
            .b-form-spinbutton
            {
                height:auto;
                padding-top: 0;
                padding-bottom: 0;
                border: 0;
            }
            &>[role="group"]
            {
                width:100%;
                border:1px solid $gray-400;
            }
            [role="spinbutton"]
            {
                border:0 !important;
                *
                {
                    text-align: center;
                    width:100%;
                    border:0;
                }
            }
        }
        &--smart-inputs
        {
            display: flex;
            //flex-wrap: wrap;
            margin-bottom:1rem;
            &>div
            {
                width:100%;
                display: flex;
                align-items: center;
                &:not(:last-child)
                {
                    //margin-bottom:0.5rem;
                }
            }
            .date
            {
                flex:1;
            }
            .hour
            {
                width:80px;
                margin-left: 10px;
            }            
            &--text
            {
                font-size: 11px;
            }
            input
            {
                text-align: center;
            }
            .danger
            {
                border-color:$danger;
                color:$danger;
            }
        }
    }

    .date-time-picker--toggle_fields
    {
        @extend .date-time-picker;
        
        position:relative;

        .date-time-picker--body
        {
            position:absolute;
            left:0;
            top:100%;
            margin-top:10px;
            z-index:100;
        }
    }
</style>